import React, { CSSProperties, JSX } from "react";

export default function Section({
  id,
  ref,
  className,
  children,
  style,
}: {
  id: string;
  ref?: any;
  className?: string;
  children: JSX.Element;
  style?: React.CSSProperties;
}) {
  return (
    <section ref={ref} id={id} className={`${className}`} style={style}>
      {children}
    </section>
  );
}
